import { useEffect } from 'react';

// project import
import useAuth from 'hooks/useAuth';

// types
import Loader from 'components/Loader';
import { GuardProps } from 'types/auth';
import { useNavigateWithReturnState } from 'utils/useNavigateWithReturnState';

// ==============================|| AUTH GUARD ||============================== //

const AuthGuard = ({ children }: GuardProps): React.ReactElement | null => {
    const { isLoggedIn, user } = useAuth();
    const navigateWithReturn = useNavigateWithReturnState();

    useEffect(() => {
        if (!isLoggedIn) {
            navigateWithReturn('login', { replace: true });
        }
    }, [isLoggedIn, navigateWithReturn]);

    if (!user) {
        return <Loader />;
    }

    return children;
};

export default AuthGuard;
